import { cn } from "@/lib/utils";
import { useAuth } from "@/providers/auth-provider";
import { useModal } from "@/providers/modal-provider";
import Lottie from "lottie-react";
import { MousePointerClickIcon } from "lucide-react";
import Link from "next/link";
import getAttention from "./getAttention.json";
import launchDay from "./launchDay.json";
import submitProduct from "./submitProduct.json";
import { ModalType } from "@/providers/modal-provider.types";

const HowToLaunch = () => {
	const { isLoggedIn } = useAuth();
	const { openModal } = useModal();

	return (
		<div className="mt-6 block h-auto w-full rounded-2xl bg-white p-4 text-center shadow-md md:flex md:max-w-full md:flex-col md:items-center md:justify-center md:space-x-6 lg:p-6">
			<h4 className="text-xl font-bold uppercase text-brand-primary">
				How to launch products on proptechbuzz for free?
			</h4>

			<div className="flex justify-center space-x-6 max-md:flex-wrap">
				<div className="flex flex-col items-center md:w-1/3">
					<div className="mb-4">
						<Lottie animationData={submitProduct} loop={true} className="h-20 w-20" />
					</div>

					<h4 className="mb-2 text-center text-lg font-semibold">Submit Product with us </h4>
					<p className="mb-4 text-center text-sm text-gray-500">
						Submit your product on PropTechBuzz{" "}
						<span className="font-bold text-brand-primary">for free</span>
					</p>
				</div>

				<div className="flex flex-col items-center md:w-1/3">
					<div className="mb-4">
						<Lottie animationData={launchDay} loop={true} className="h-20 w-20" />
					</div>
					<h4 className="mb-2 text-center text-lg font-semibold">Launch Day</h4>
					<p className="mb-4 text-center text-sm text-gray-500">
						Every day we <span className="font-bold text-brand-primary">select and launch</span>{" "}
						8-12 Products that have submitted with us.
					</p>
				</div>

				<div className="flex flex-col items-center md:w-1/3">
					<div className="mb-4">
						<Lottie animationData={getAttention} loop={true} className="h-20 w-20" />
					</div>
					<h4 className="mb-2 text-center text-lg font-semibold">Get Attention</h4>
					<p className="mb-4 text-center text-sm text-gray-500">
						Reach <span className="font-bold text-brand-primary">100K global audience</span> weekly,
						with a chance to win product spotlight based on votes.
					</p>
				</div>
			</div>

			<div className="mt-6 flex items-center justify-center gap-4 max-md:flex-wrap">
				<Link
					href="https://www.proptechbuzz.com/how-it-works"
					target="_blank"
					className={cn(
						"flex items-center rounded border px-8 py-2 text-sm font-semibold transition"
					)}
				>
					Learn More about How It Works
				</Link>

				{!isLoggedIn ? (
					<button
						onClick={() => openModal(ModalType.Auth)}
						className={cn(
							"flex items-center gap-2 rounded bg-[#005EFF] px-6 py-2 text-sm font-semibold text-white transition",
							"hover:bg-blue-700 active:bg-blue-700"
						)}
					>
						Submit Your Product <MousePointerClickIcon className="h-4 w-4 text-inherit" />
					</button>
				) : (
					<Link
						href="/products/form/getting-started"
						target="_blank"
						className={cn(
							"flex items-center gap-2 rounded bg-[#005EFF] px-6 py-2 text-sm font-semibold text-white transition",
							"hover:bg-blue-700 active:bg-blue-700"
						)}
					>
						Submit Your Product <MousePointerClickIcon className="h-4 w-4 text-inherit" />
					</Link>
				)}
			</div>
		</div>
	);
};

export default HowToLaunch;
